<h2 mat-dialog-title>Add Comment</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Enter your comment</mat-label>
    <textarea matInput [(ngModel)]="comment"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()">Submit</button>
</mat-dialog-actions>
